const STATUS = {
  loading: 'loading',
  resolved: 'resolved',
  rejected: 'rejected',
};

export const states = {
  [STATUS.loading]: (data, payload) => ({
    loading: true,
    error: null,
    data: null,
    payload,
  }),
  [STATUS.resolved]: (data, payload) => ({
    loading: false,
    error: null,
    data,
    payload,
  }),
  [STATUS.rejected]: (error, payload) => ({
    loading: false,
    error: error.data ? error.data : error.toString(),
    errorStatus: error.status,
    data: null,
    payload,
  }),
};

export function createState(status, data = null, payload = null) {
  return states[status](data, payload);
}

export default STATUS;
